export default __webpack_public_path__ + "static/media/happy.20860fb1.mp4";